import types from './types';
import descriptions from '../queries/descriptions';

export default ({ commit, rootState }) => {
  const { activePost } = rootState.classIndex;

  descriptions.load(activePost.id)
    .then((response) => {
      const { data } = response;
      const description = data.post.description;

      commit(types.SET_ACTIVE_DESCRIPTION, description);
    });
};



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Description/store/actions.js